module.exports = __webpack_public_path__ + "static/img/c2.ad4085c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/c2.png
// module id = OBRL
// module chunks = 0